import React, { useState, useEffect } from "react";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  FormGroup,
  Label,
  Input,
} from "reactstrap";
import { updateReport } from "./reportedHotspotApi";

const EditReportModal = ({ isOpen, toggle, report, onUpdate }) => {
  const [state, setState] = useState("");
  const [adminNote, setAdminNote] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (report) {
      // Use the report's state, or empty string if not set
      setState(report.state || "");
      setAdminNote(report.admin_note || "");
    }
  }, [report]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!report || !report.report_id) {
      return;
    }

    if (!state) {
      alert("Please select a state");
      setLoading(false);
      return;
    }

    setLoading(true);
    try {
      const updateData = {
        report_ids: [report.report_id],
        state: state,
      };

      // Only include adminNote if it has content
      if (adminNote && adminNote.trim()) {
        updateData.adminNote = adminNote.trim();
      }

      await updateReport(updateData);

      // Call onUpdate callback to refresh the reports list
      if (onUpdate) {
        onUpdate();
      }

      toggle();
    } catch (error) {
      console.error("Error updating report:", error);
      alert(error.response?.data?.message || error.message || "Failed to update report");
    } finally {
      setLoading(false);
    }
  };

  const handleClose = () => {
    if (report) {
      setState(report.state || "");
      setAdminNote(report.admin_note || "");
    }
    toggle();
  };

  return (
    <Modal isOpen={isOpen} toggle={handleClose} centered>
      <form onSubmit={handleSubmit}>
        <ModalHeader toggle={handleClose}>
          <i className="mdi mdi-pencil me-2"></i>
          Edit Report
        </ModalHeader>
        <ModalBody>
          {report && (
            <>
              <div className="mb-3">
                <small className="text-muted">Report ID: {report.report_id}</small>
              </div>

              <FormGroup>
                <Label>State</Label>
                <Input
                  type="select"
                  value={state}
                  onChange={(e) => setState(e.target.value)}
                >
                  <option value="">-- Select State --</option>
                  <option value="raised">Raised</option>
                  <option value="inProgress">In Progress</option>
                  <option value="resolved">Resolved</option>
                </Input>
              </FormGroup>

              <FormGroup>
                <Label>Admin Note</Label>
                <Input
                  type="textarea"
                  rows="4"
                  value={adminNote}
                  onChange={(e) => setAdminNote(e.target.value)}
                  placeholder="Enter admin note..."
                />
              </FormGroup>
            </>
          )}
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={handleClose} disabled={loading}>
            Cancel
          </Button>
          <Button color="primary" type="submit" disabled={loading}>
            {loading ? (
              <>
                <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                Updating...
              </>
            ) : (
              <>
                <i className="mdi mdi-check me-2"></i>
                Update
              </>
            )}
          </Button>
        </ModalFooter>
      </form>
    </Modal>
  );
};

export default EditReportModal;

